module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x3-daf44a673f18a2ace5e056487439890f.jpg";